const failureMessages = {
    invalidUserCredentials: 'Invalid user credentials',
    userNotFound: "User not found!",
    passwordInvalidContent: "Password must have a minimum length of 8 characters containing at least one number, an uppercase, and a special character",
    passwordOldPasswordIsSame: "Old password and new password cannot be the same",
    mailInvalidContent: 'Invalid email format',
    phoneInvalidContent: "Please enter valid phone number",
    confirmPasswordMsg: "Passwords must match",
    passwordIsMissing: "Password field is missing",
    confirmPasswordIsMissing: "confirmPassword field is missing",
    phoneNumberAssignedToLead: "Your Phone Number is set as preferred contact in your lead",
    emailAlreadyExist: "This account is already registered… Please login",
    emailNotRegistered: "Email is not registered",
    authorizationMissing: 'Authorization is missing',
    notBearer: "Authorization header is not type of Bearer",
    notBearerType: "Authorization header has too many part is must follow this patter 'Bearer xx.yy.zz",
    paymentNotCompleted: "Payment is not completed, please retry",
    leadUIDIsMissing: "Lead UID is missing. Please refresh the page and try again",
    leadNotFound: "Lead is not found",
    domainNameIsMissing: "domainName key is mandatory",
    UIDIsMissing: "UID is required",
    EbookMaxDownloadMsg: "You have downloaded E-book two times already",
    notAuthorizedMsg: "You are not authorized to access this page",
    userAlreadyExist: "User already exists, please login!",
    commentFieldIsEmpty: "Comment field is empty!",
    fieldIsEmpty: "Field is empty",
    userUIDIsMissing: "userUID is missing",
    OTPIsMissing: 'Please enter OTP!',
    requiredFieldIsMissing: 'Required field is missing!',
    OTPExpired: 'OTP Expired!',
    registrarUIDIsMissing: "Registrar UID is missing",
    permissionDenied: "Permission denied!",
    fieldsMissingMessage: "Fields are missing",
    payloadEmpty: "Payload is empty",
    invalidEntry: "Invalid entry",
    errorParsingData: "Error in parsing request",
    enterPhoneNumber: "Please enter phone number",
    imageOnlyError: "Please upload only .jpg, .jpeg, .png type files",
    requestBodyIsInvalid: "The request body is invalid",
    inValidImageType: "Invalid image input",
    registrarUIDNotFound: "Registrar UID is not found!",
    unknownInputField: "Unknown input field",
    unexpectedPayloadInput: "Unexpected input field",
    somethingWentWrong: "Something went wrong!",
    userProfileMissingInJWT: "Error while generating token :userProfile is null",
    generatingToken: "error generating token",
    errorVerifyingToken: "Error verifying token",
    tokenNotValid: "Token is not valid!",
    inputValueIsTooLong: "Input value is too long",
    emptyEmail: "Email field should not be empty",
    errorInSendingMailTo: "Error in sending mail to",
    invalidDomainName: "The domain name you looking for is not a valid one",
    invalidDateFormat: "Invalid date format",
    entryNotFound: "Entry not found",
    dataNotFound: "Data not found",
    dataAlreadyExist: "Data already exist ",
    noSuchPaymentMethod: "No such PaymentMethod",
    promoCodeExpired: "Promo code is expired",
    promoCodeIsNotValid: "Promo code invalid",
    promoCodeIsUsed: "Promo is code already used",
    alreadyPaid: "Payment already done",
    invalidEmail: "Email is not valid, Please enter valid email address",
    promoUsedBySameUser: "You have used this promo code already",
    invalidRoleID: "Role Id is invalid",
    opportunityError: "Failed to create a opportunity, Please contact admin",
    appraisalNotFound: "I'm working on this appraisal it may take a few minutes, please retry after a few minutes",
    restrictAppraisal: "Please login to get appraisals",
    todayLimitExceeded: "You have exceeded the maximum limit today.",
    roleTypeInvalid: "Invalid role type",
    updateFailed: "Update failed"
}

export default failureMessages

